import Container from 'react-bootstrap/Container';
import Table from 'react-bootstrap/Table';
import { typeRelationsCalculator } from '../../../calculators/socionics/functions/typeRelationsCalculator'
import { whichRelationIsThis } from '../../../calculators/socionics/functions/whichRelation';
import { whichColor } from '../../../calculators/socionics/functions/colors'
import PopUpModal from '../cards/PopupModal';
import { typeInfo } from '../../../data/socionics/data/typesInfo'

function RelationsTable(props) {
    let tempScores = typeRelationsCalculator();

    let i = 0;
    let x = 0;
    let scores = [
        [], [], [], [],
        [], [], [], [],
        [], [], [], [],
        [], [], [], []
    ];

    let relations = [
        [], [], [], [],
        [], [], [], [],
        [], [], [], [],
        [], [], [], []
    ];

    for (i; i < 256; i++) {
        if (i !== 0 && i % 16 === 0) {
            x++
        }
        scores[x].push(tempScores[i])
        relations[x].push(whichRelationIsThis(tempScores[i]))
    }
    let rowItems = props.data.map((_, index) => (
        <tr key={index}>
            <td className='fw-bolder' >{_}</td>
            {
                relations[index].map((_, item) => (
                    <td key={item} style={{ backgroundColor: whichColor(scores[index][item]), cursor: 'pointer' }}>
                        <PopUpModal
                            item={relations[index][item]}
                            heading={relations[index][item]}
                            body={typeInfo[scores[index][item] - 1]} />
                    </td>
                ))
            }
        </tr>
    ))
    return (
<Container className='pb-5 pt-2'>
        <Table className='w-50 m-auto' style={{ fontSize: '11px',fontWeight:'bold' }} responsive bordered size="sm">
            <thead>
                <tr >
                    <th className='px-0' >#</th>
                    {props.data.map((_, index) => (
                        <th className='fw-bolder' key={index}>{_}</th>
                    ))}
                </tr>
            </thead>
            <tbody>
                {rowItems}
            </tbody>
        </Table>
        </Container>
    );
}

export default RelationsTable;